import Cleave from "cleave.js"
import { Directive } from "vue"
import { CleaveOptions } from "cleave.js/options"

interface CleaveHTMLElement extends HTMLElement {
    cleave: Cleave
}

export const cleaveDirective: Directive<CleaveHTMLElement, CleaveOptions> = {
    mounted(el, binding) {
        const options = binding.value || {}
        el.cleave = new Cleave(el, options)
    },
    unmounted(el) {
        if (el.cleave) {
            el.cleave.destroy()
        }
    },
}
